var customerOrVisitorWishlists = [];
var customerWishlistedTmProductIds = [];
var removeCollaboratorFromWishlistAjax = null;
var addingTmProductIdToWishlist = null;
var creatingWishlistOnly = false; // Wishlists page "New wishlist" card: create an empty list (no product)
var movingTmProductIdToWishlist = null; // "Change" on the saved toast: the product moves from its list to the chosen one
var wishlistLastUsedKey = 'wishlist-last-used-list'; // localStorage: the list the heart saves into when there are several
var editingWishlistGroupToken = null;
var deletingWishlistGroupToken = null;
var settingsWishlistObject = null;
var wishlistTravelDatesPicker = null;
var wishlistLightpickMouseDownAt = 0;
var wishlistDetailPageWishlistObject = typeof wishlistDetailPageWishlistObject !== 'undefined' ? wishlistDetailPageWishlistObject : null;
var wishlistModalEl = $('#wishlist-modal');
var wishlistEmptyIcon = 'fa-light fa-heart fa-fw'; // same as the base icon map ($icons['heart'])
var wishlistFillIcon = 'fa-solid fa-heart fa-fw';

tmWishlist = function () {
    return {
        // A list name as stored (magic-quoted by WordPress: Kid\'s) as the customer typed it, like PHP's stripslashes()
        unescapeName: function (name) {
            return String(name || '').replace(/\\(.)/g, '$1');
        },

        // Chooser rows ("Add to wishlist" / "Change"): thumb, name, "N tours & activities" (labels from the modal's data attributes)
        wishlistCountLabel: function (count) {
            let singular = wishlistModalEl.attr('data-product-singular') || 'experience';
            let extended = wishlistModalEl.attr('data-product-extended') || 'experiences';
            return count + ' ' + (count === 1 ? singular : extended);
        },

        wishlistFolderHtmlTemplate: function (customerOrVisitorWishlist) {
            let wishlistSavedCount = customerOrVisitorWishlist.hasOwnProperty('wishlist_tm_product_ids') && customerOrVisitorWishlist.wishlist_tm_product_ids.length >= 0 ? customerOrVisitorWishlist.wishlist_tm_product_ids.length : 0;
            let wishlistThumbImgUrl = customerOrVisitorWishlist.hasOwnProperty('wishlist_thumb_url') ? customerOrVisitorWishlist.wishlist_thumb_url : null;
            let name = $('<div>').text(tmWishlist.unescapeName(customerOrVisitorWishlist.name)).html();

            return '<button type="button" class="wishlist-folder-selector wishlist-row" data-id="' + customerOrVisitorWishlist.id + '">' +
                    '   <span class="wishlist-row__thumb">' +
                            (wishlistThumbImgUrl ? '<img alt="" src="'+wishlistThumbImgUrl+'" />' : '<span class="wishlist-row__thumb-empty"><i class="'+wishlistEmptyIcon+'" aria-hidden="true"></i></span>')  +
                    '   </span>' +
                    '   <span class="wishlist-row__text">' +
                    '       <span class="wishlist-row__name">' + name + '</span>' +
                    '       <span class="wishlist-row__count">' + tmWishlist.wishlistCountLabel(wishlistSavedCount) + '</span>' +
                    '   </span>' +
                    '</button>';
        },

        wishlistNewRowHtmlTemplate: function () {
            return '<button type="button" class="wishlist-row wishlist-row--new" id="wishlist-modal-new-wishlist-row">' +
                    '   <span class="wishlist-row__thumb"><span class="wishlist-row__thumb-new"><i class="fa-light fa-plus" aria-hidden="true"></i></span></span>' +
                    '   <span class="wishlist-row__text"><span class="wishlist-row__name">New wishlist</span></span>' +
                    '</button>';
        },

        processCustomerOrVisitorWishlists: function () {
            customerWishlistedTmProductIds = [];
            let wishlistItemsGridHtml = tmWishlist.wishlistNewRowHtmlTemplate();
            let lastUsedWishlist = tmWishlist.defaultWishlistForSave(); // the most recently used list sits right under "New wishlist" (Peter, 2026-09-18)
            let orderedWishlists = lastUsedWishlist
                ? [lastUsedWishlist].concat(customerOrVisitorWishlists.filter(function (list) { return list !== lastUsedWishlist; }))
                : customerOrVisitorWishlists;
            orderedWishlists.forEach(function (customerOrVisitorWishlist) {
                if (customerOrVisitorWishlist.hasOwnProperty('wishlist_tm_product_ids')) {
                    customerWishlistedTmProductIds = customerWishlistedTmProductIds.concat(customerOrVisitorWishlist.wishlist_tm_product_ids)
                }
                wishlistItemsGridHtml += tmWishlist.wishlistFolderHtmlTemplate(customerOrVisitorWishlist);
            })
            wishlistModalEl.find('.wishlist-items-grid').html(wishlistItemsGridHtml);
            tmWishlist.refreshWishlistStatusToAllProducts();
        },

        // The list a heart saves into without asking: the last one used here, else the newest list
        defaultWishlistForSave: function () {
            let lastUsed = null;
            try { lastUsed = window.localStorage.getItem(wishlistLastUsedKey); } catch (e) {}
            let found = lastUsed ? customerOrVisitorWishlists.find(function (list) { return String(list.id) === String(lastUsed); }) : null;
            return found || customerOrVisitorWishlists[0] || null;
        },

        rememberWishlistUsed: function (tmWishlistId) {
            try { window.localStorage.setItem(wishlistLastUsedKey, String(tmWishlistId)); } catch (e) {}
        },

        // "Change" on the toast: the product leaves every list of this visitor, then joins the chosen (or a new) one
        moveProductToWishlist: function (tmProductId, tmWishlistId = null, tmWishlistNameIfNew = '') {
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "add_remove_visitor_customer_wishlist_item",
                    "tm_product_id": tmProductId,
                    "add_or_remove" : 'remove',
                    "tmv_identifier" : tmVisitorStore.getDetail('identifier'),
                },
                complete () {
                    tmWishlist.addRemoveProductToCustomerWishlist(tmProductId, 'add', tmWishlistId, tmWishlistNameIfNew);
                }
            });
        },

        toggleWishlistStatusForTmProduct: function (tmProductId, actionOnlyForAdd = false) {
            if (customerWishlistedTmProductIds.includes(tmProductId))  {
                if (!actionOnlyForAdd) {
                    tmWishlist.addRemoveProductToCustomerWishlist(tmProductId, 'remove');
                }
            }
            else {
                try{
                    tmUtils.fbqTrack('AddToWishlist'); // the Meta pixel only with advertising consent (Consent banner Flow 6)
                } catch (e) {}
                addingTmProductIdToWishlist = tmProductId;
                let saveInto = tmWishlist.defaultWishlistForSave();
                if (saveInto && saveInto.id > 0) {
                    // a list exists: save straight into it, no modal (Peter, 2026-09-17); the toast names it and,
                    // with several lists, offers "Change"
                    tmWishlist.addRemoveProductToCustomerWishlist(tmProductId, 'add', saveInto.id);
                    addingTmProductIdToWishlist = null;
                }
                else {
                    tmWishlist.showWishlistModal('createList');
                }
            }
        },

        // "Undo" on the removed toast: the product goes back into every list it was just taken out of
        undoRemoveProductFromWishlists: function (tmProductId, tmWishlistIds) {
            let ids = (tmWishlistIds || []).slice();
            if (!ids.length) {
                return;
            }
            let restoreNext = function () {
                let listId = ids.shift();
                tmWishlist.addRemoveProductToCustomerWishlist(tmProductId, 'add', listId, '', ids.length ? restoreNext : null);
            };
            restoreNext();
        },

        addRemoveProductToCustomerWishlist: function(tmProductId, addOrRemove = 'add', tmWishlistId = null, tmWishlistNameIfNew = '', thenQuietly = null) {
            // remove takes the product out of every list of this visitor; remember them so the toast can undo it
            let removedFromIds = addOrRemove === 'remove' ? customerOrVisitorWishlists.filter(function (list) {
                return (list.wishlist_tm_product_ids || []).map(String).includes(String(tmProductId));
            }).map(function (list) { return list.id; }) : [];
            let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');
            let dateStart = travelDatesInputEl ? (travelDatesInputEl.getAttribute('data-date-start') || '') : '';
            let dateEnd = travelDatesInputEl ? (travelDatesInputEl.getAttribute('data-date-end') || '') : '';
            if (dateStart && !dateEnd) {
                dateEnd = dateStart;
            }
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "add_remove_visitor_customer_wishlist_item",
                    "tm_product_id": tmProductId,
                    "add_or_remove" : addOrRemove,
                    "tm_wishlist_id" : tmWishlistId,
                    "tm_wishlist_name" : tmWishlistNameIfNew,
                    "date_start" : dateStart,
                    "date_end" : dateEnd,
                    "tmv_identifier" : tmVisitorStore.getDetail('identifier'),
                },
                success ( returnJSON ) {
                    if (returnJSON.hasOwnProperty('customerOrVisitorWishlists')) {
                        customerOrVisitorWishlists = returnJSON.customerOrVisitorWishlists;
                        tmWishlist.processCustomerOrVisitorWishlists();
                        if (addOrRemove === 'add' && typeof thenQuietly === 'function') {
                            thenQuietly(); // undo across several lists: only the last restore toasts
                        }
                        else if (addOrRemove === 'add') {
                            // name the list, linked (Peter, 2026-09-17): the list the product now sits in
                            let savedTo = customerOrVisitorWishlists.find(function (list) {
                                return (list.wishlist_tm_product_ids || []).map(String).includes(String(tmProductId));
                            }) || null;
                            let text = 'Saved to your wishlist';
                            if (savedTo && savedTo.token) {
                                tmWishlist.rememberWishlistUsed(savedTo.id);
                                text = 'Saved to<br><a class="tm-toaster-link" href="' + window.location.origin + '/wishlist/' + savedTo.token + '">' + $('<div>').text(tmWishlist.unescapeName(savedTo.name)).html() + '</a>';
                                if (customerOrVisitorWishlists.length > 1) { // several lists: the toast offers to move it
                                    text += ' <a href="#" class="tm-toaster-link tm-toaster-change-wishlist" data-tm-product-id="' + tmProductId + '">Change</a>';
                                }
                            }
                            jQuery(document).trigger('tmToasterTrigger', {icon: wishlistFillIcon, text: text, duration: customerOrVisitorWishlists.length > 1 ? 6000 : 4000});
                        }
                        else if (addOrRemove === 'remove'){
                            let text = 'Removed from your wishlist';
                            if (removedFromIds.length) {
                                text += ' <a href="#" class="tm-toaster-link tm-toaster-undo-remove" data-tm-product-id="' + tmProductId + '" data-tm-wishlist-ids="' + removedFromIds.join(',') + '">Undo</a>';
                            }
                            jQuery(document).trigger('tmToasterTrigger', {icon: wishlistEmptyIcon, text: text, duration: removedFromIds.length ? 6000 : 1000});
                        }
                    }
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistPage(tmProductId);
                }
            })
        },

        createWishlistGroup: function (tmWishlistName) {
            let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');
            let dateStart = travelDatesInputEl ? (travelDatesInputEl.getAttribute('data-date-start') || '') : '';
            let dateEnd = travelDatesInputEl ? (travelDatesInputEl.getAttribute('data-date-end') || '') : '';
            if (dateStart && !dateEnd) {
                dateEnd = dateStart;
            }
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "create_visitor_customer_wishlist_group",
                    "name": tmWishlistName,
                    "date_start": dateStart,
                    "date_end": dateEnd,
                    "tmv_identifier": tmVisitorStore.getDetail('identifier'),
                },
                success (returnJSON) {
                    if (returnJSON && returnJSON.token) {
                        tmWishlist.redirectToWishlistDetailPage(returnJSON.token);
                    }
                    else {
                        tmWishlist.redirectToWishlistPage();
                    }
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistPage();
                }
            })
        },

        deleteWishlistGroup: function (tmWishlistToken) {
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "delete_visitor_customer_wishlist_group",
                    "tm_wishlist_token" : tmWishlistToken,
                },
                success () {
                    tmWishlist.redirectToWishlistPage();
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistPage();
                }
            })
        },

        renameWishlistGroup: function (tmWishlistToken, tmWishlistName) {
            let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');
            let data = {
                "action": "rename_visitor_customer_wishlist_group",
                "tm_wishlist_token" : tmWishlistToken,
                "tmv_identifier" : tmVisitorStore.getDetail('identifier'),
            };
            if (!settingsWishlistObject || tmWishlist.unescapeName(settingsWishlistObject.name) !== tmWishlistName) {
                data.name = tmWishlistName; // only a new name: a dates-only save leaves the stored name as it is
            }
            if (travelDatesInputEl) { // the modal only carries Travel Dates with the 2025 pieces on (?next, the confirmation page); without the field the list's dates are left alone
                data.date_start = travelDatesInputEl.getAttribute('data-date-start') || '';
                data.date_end = travelDatesInputEl.getAttribute('data-date-end') || data.date_start;
            }
            jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: data,
                success () {
                    tmWishlist.redirectToWishlistDetailPage(tmWishlistToken);
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistDetailPage(tmWishlistToken);
                }
            })
        },

        removeCollaboratorFromWishlist: function (collaborateAction, tmWishlistToken, tmwuId) {
            if (removeCollaboratorFromWishlistAjax) {
                return;
            }
            removeCollaboratorFromWishlistAjax = jQuery.ajax({
                type: "post",
                url: ajaxurl,
                dataType: "json",
                data: {
                    "action": "leave_remove_wishlist_collaborator",
                    "tm_wishlist_token" : tmWishlistToken,
                    "tmwu_id": tmwuId,
                    "collaborate_action": collaborateAction,
                },
                success (returnJSON) {
                    if (returnJSON.wishlist_collaborators && collaborateAction === 'remove') {
                        wishlistDetailPageWishlistObject.wishlist_collaborators = returnJSON.wishlist_collaborators;
                        tmWishlist.hideWishlistModal();
                    }
                    else {
                        tmWishlist.redirectToWishlistDetailPage(tmWishlistToken);
                    }
                },
                error(jqXHR, textStatus, errorThrown) {
                    tmWishlist.redirectToWishlistDetailPage(tmWishlistToken);
                },
                complete() {
                    removeCollaboratorFromWishlistAjax = null;
                }
            })
        },

        processTmProductWishlistStatus: function (favouriteIconEl) {
            let favouriteIconElTmActivityId = favouriteIconEl.attr('data-tm-activity-id') ?? null;
            if (customerWishlistedTmProductIds.includes(favouriteIconElTmActivityId)) {
                favouriteIconEl.find("i").removeClass("far fa-regular fa-light").addClass("fa-solid");
                favouriteIconEl.find('.wish-list-title').text( 'Added to Wishlist' );
                if ( $("#tm-account-dashboard .wish-list-carousel").length !== 0 ){ // undo after a remove on the wishlist page
                    $("#tm-account-dashboard .wish-list-carousel [data-tm-activity-id=" + favouriteIconElTmActivityId + "]").parents(".c-product-carousel__slide").filter(':hidden').fadeIn(300);
                }
            }
            else {
                favouriteIconEl.find("i").removeClass("fas fa-solid").addClass("fa-regular");

                favouriteIconEl.find('.wish-list-title').text( 'Add to Wishlist' );
                if ( $("#tm-account-dashboard .wish-list-carousel").length !== 0 ){
                    let wishlistPageRemovedProductEl = $("#tm-account-dashboard .wish-list-carousel [data-tm-activity-id=" + favouriteIconElTmActivityId + "]");
                    wishlistPageRemovedProductEl.parents(".c-product-carousel__slide").fadeOut(500);
                }
            }
        },

        refreshWishlistStatusToAllProducts: function () {
            let wishlistableIcons = $('.favorite-icon');
            wishlistableIcons.each(function (i, obj) {
                tmWishlist.processTmProductWishlistStatus($(obj));
            });
        },

        redirectToWishlistPage: function (tmProductId = null) {
            let url = window.location.origin +"/wishlist/";
            if (tmProductId) {
                url += '?add_to_wishlist=' + tmProductId;
            }
            window.location = url;
        },

        redirectToWishlistDetailPage: function (tmWishlistToken) {
            window.location = window.location.origin + "/wishlist/" + tmWishlistToken;
        },

        validateModalWishlistCreate: function (validateFor = 'create') {
            let wishlistName = $('#wishlist-modal #wishlist-modal-new-edit-wishlist-name').val().trim();
            if (validateFor === 'create') {              

                if (wishlistName.length > 0 && wishlistName.length <= 50) {
                    $('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').attr('disabled', false);
                    return wishlistName;
                }
                else {
                    $('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').attr('disabled', true);
                }
            }
            else if (validateFor === 'edit') {
                let currentDateStart = '';
                let currentDateEnd = '';
                let originalDateStart = '';
                let originalDateEnd = '';
                let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');

                if (travelDatesInputEl) {
                    currentDateStart = travelDatesInputEl.getAttribute('data-date-start') || '';
                    currentDateEnd = travelDatesInputEl.getAttribute('data-date-end') || '';
                }
                if (settingsWishlistObject) {
                    originalDateStart = settingsWishlistObject.date_start || '';
                    originalDateEnd = settingsWishlistObject.date_end || '';
                }

                if (currentDateStart && !currentDateEnd) {
                    currentDateEnd = currentDateStart;
                }
                if (originalDateStart && !originalDateEnd) {
                    originalDateEnd = originalDateStart;
                }

                let nameChanged = settingsWishlistObject
                    && settingsWishlistObject.hasOwnProperty('name')
                    && tmWishlist.unescapeName(settingsWishlistObject.name) !== wishlistName;
                let datesChanged = false;
                if (travelDatesInputEl) {
                    datesChanged = (currentDateStart !== originalDateStart) || (currentDateEnd !== originalDateEnd);
                }

                if (wishlistName.length > 0 && wishlistName.length <= 50 && editingWishlistGroupToken !== null && settingsWishlistObject && settingsWishlistObject.hasOwnProperty('name') && (nameChanged || datesChanged)) {
                    $('#wishlist-modal #wishlist-modal-edit-list-footer-submit').attr('disabled', false);
                    return wishlistName;
                }
                else {
                    $('#wishlist-modal #wishlist-modal-edit-list-footer-submit').attr('disabled', true);
                }
            }

            return null;
        },

        // Desktop: the calendar is position: fixed (style.scss .wishlist-calendar); anchor it to the field —
        // below it when there is room, else above — instead of the top of the viewport
        positionWishlistTravelDatesPicker: function (travelDatesInputEl) {
            if (!wishlistTravelDatesPicker || !wishlistTravelDatesPicker.el || window.innerWidth < 1025) {
                return;
            }
            let field = travelDatesInputEl.getBoundingClientRect();
            let cal = wishlistTravelDatesPicker.el.getBoundingClientRect();
            let gap = 8;
            let top = field.bottom + gap;
            if (top + cal.height > window.innerHeight) {
                top = field.top - cal.height - gap;
            }
            wishlistTravelDatesPicker.el.style.top = Math.max(gap, Math.round(top)) + 'px';
            wishlistTravelDatesPicker.el.style.left = Math.round(field.left) + 'px';
        },

        updateWishlistTravelDatesLabelState: function (travelDatesInputEl) {
            let wrapperEl = $(travelDatesInputEl).closest('.wishlist-modal-new-edit-wishlist-travel-dates-wrapper');
            if (!wrapperEl.length) {
                wrapperEl = $(travelDatesInputEl).closest('.custom-select');
            }
            if (!wrapperEl.length) {
                return;
            }

            let labelEl = wrapperEl.find('label')[0] ?? null;
            if (!labelEl) {
                return;
            }

            if (travelDatesInputEl.value && travelDatesInputEl.value.trim().length > 0) {
                wrapperEl.removeClass('wishlist-date-empty');
                wrapperEl.addClass('wishlist-date-selected');
            } else {
                wrapperEl.addClass('wishlist-date-empty');
                wrapperEl.removeClass('wishlist-date-selected');
            }
        },

        initWishlistTravelDatesPicker: function () {
            if (typeof Lightpick === 'undefined' || typeof moment === 'undefined') {
                return;
            }

            let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');
            if (!travelDatesInputEl) {
                return;
            }

            if (wishlistTravelDatesPicker && wishlistTravelDatesPicker._opts && wishlistTravelDatesPicker._opts.field === travelDatesInputEl) {
                return;
            }

            if (wishlistTravelDatesPicker && typeof wishlistTravelDatesPicker.destroy === 'function') {
                wishlistTravelDatesPicker.destroy();
            }

            let presetDateStart = travelDatesInputEl.getAttribute('data-date-start') || '';
            let presetDateEnd = travelDatesInputEl.getAttribute('data-date-end') || '';
            if (presetDateStart && !presetDateEnd) {
                presetDateEnd = presetDateStart;
            }

            wishlistTravelDatesPicker = new Lightpick({
                field: travelDatesInputEl,
                singleDate: false,
                footer: true,
                minDate: moment(),
                format: 'MMM D, YYYY',
                numberOfMonths: parseInt(1),
                dropdowns: false,
                orientation: 'top',
                fieldWidth: true,
                wishlistCalendar: true,
                parentEl: '.wishlist-modal-new-edit-wishlist-travel-dates-wrapper',
                startDate: presetDateStart || null,
                endDate: presetDateEnd || null,
                locale: {
                    buttons: {
                    prev: '<i class="fas fa-chevron-left"></i>',
                    next: '<i class="fas fa-chevron-right"></i>',
                    reset: 'Reset',
                    apply: 'Apply'
                    },
                },                
                onSelect: function (start, end) {
                    let isRangeInProgress = travelDatesInputEl.value && travelDatesInputEl.value.includes('...');
                    if (isRangeInProgress) {
                        end = null;
                        if (typeof this.setEndDate === 'function') {
                            this.setEndDate(null, true);
                        }
                        travelDatesInputEl.removeAttribute('data-date-end');
                    }

                    if (start == null && end == null) {
                        travelDatesInputEl.value = '';
                        travelDatesInputEl.removeAttribute('data-date-start');
                        travelDatesInputEl.removeAttribute('data-date-end');
                        tmWishlist.updateWishlistTravelDatesLabelState(travelDatesInputEl);
                        tmWishlist.validateModalWishlistCreate('edit');
                        return;
                    }

                    if (start && !end) {
                        travelDatesInputEl.value = start.format('MMM D, YYYY');
                        travelDatesInputEl.setAttribute('data-date-start', start.format('YYYY-MM-DD'));
                        travelDatesInputEl.removeAttribute('data-date-end');
                        tmWishlist.updateWishlistTravelDatesLabelState(travelDatesInputEl);
                        tmWishlist.validateModalWishlistCreate('edit');
                        return;
                    }

                    if (start && end) {
                        if (start.format('YYYY-MM-DD') === end.format('YYYY-MM-DD')) {
                            travelDatesInputEl.value = start.format('MMM D, YYYY');
                        } else {
                            travelDatesInputEl.value = start.format('MMM D, YYYY') + ' - ' + end.format('MMM D, YYYY');
                        }
                        travelDatesInputEl.setAttribute('data-date-start', start.format('YYYY-MM-DD'));
                        travelDatesInputEl.setAttribute('data-date-end', end.format('YYYY-MM-DD'));
                        tmWishlist.updateWishlistTravelDatesLabelState(travelDatesInputEl);
                        tmWishlist.validateModalWishlistCreate('edit');
                    }
                },
                onOpen: function () {
                    if (typeof fixDatePickerStyling === 'function') {
                        fixDatePickerStyling();
                    }
                }
            });

            if (typeof attachNewArrowsEvents === 'function') {
                attachNewArrowsEvents(wishlistTravelDatesPicker);
            }

            if (presetDateStart && presetDateEnd && presetDateStart === presetDateEnd) {
                let sameDay = moment(presetDateStart, 'YYYY-MM-DD');
                if (sameDay.isValid()) {
                    travelDatesInputEl.value = sameDay.format('MMM D, YYYY');
                }
            }

            tmWishlist.updateWishlistTravelDatesLabelState(travelDatesInputEl);
        },

        showWishlistModal: function (subType = 'chooseList') {
            let wishlistModalHeading = '';
            wishlistModalEl.find(".display-contents-inner").removeClass().addClass('display-contents-inner ' + subType);
            wishlistModalEl.find('#wishlist-modal-existing-lists').hide();
            wishlistModalEl.find('#wishlist-modal-create-edit-new-list').hide();
            wishlistModalEl.find('#wishlist-modal-existing-lists-footer').hide();
            wishlistModalEl.find('#wishlist-modal-create-new-list-footer').hide();
            wishlistModalEl.find('#wishlist-modal-edit-list-footer').hide();
            wishlistModalEl.find('#setting-options').hide();
            wishlistModalEl.find('#wishlist-share-entry').hide();
            wishlistModalEl.find('#wishlist-share-invite-public-link').hide();
            wishlistModalEl.find('#wishlist-share-invite-collaborators-link').hide();
            wishlistModalEl.find('#wishlist-share-collaborators-list').hide();
            wishlistModalEl.find('.modal-footer').show();

            wishlistModalEl.removeClass('small-modal');
            if (subType === 'chooseList' && addingTmProductIdToWishlist) {
                wishlistModalHeading = movingTmProductIdToWishlist ? 'Change wishlist' : 'Add to wishlist';
                wishlistModalEl.find('#wishlist-modal-existing-lists').show();
                wishlistModalEl.find('.modal-footer').hide(); // the "New wishlist" row replaces the footer button
            }
            else if (subType === 'createList' && (addingTmProductIdToWishlist || creatingWishlistOnly)) {
                wishlistModalHeading = 'Create wishlist';
                wishlistModalEl.find('#wishlist-modal-create-edit-new-list').show();
                wishlistModalEl.find('#wishlist-modal-create-new-list-footer').show();
                tmWishlist.validateModalWishlistCreate('create');
                let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');
                if (travelDatesInputEl) {
                    travelDatesInputEl.value = '';
                    travelDatesInputEl.removeAttribute('data-date-start');
                    travelDatesInputEl.removeAttribute('data-date-end');
                    tmWishlist.updateWishlistTravelDatesLabelState(travelDatesInputEl);
                }
            }
            else if (subType === 'wishlistItemSettings' && settingsWishlistObject) {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'Settings';
                wishlistModalEl.addClass('small-modal');
                // the share rows need the page's list (share links) and its owner
                let canShare = !!(wishlistDetailPageWishlistObject && wishlistDetailPageWishlistObject.share_links && wishlistDetailPageWishlistObject.tmwu_role === 'owner');
                wishlistModalEl.find('#setting-options .setting-option--owner').toggle(canShare);
                wishlistModalEl.find('#setting-options').show();
            }
            else if (subType === 'wishlistItemRename' && settingsWishlistObject && editingWishlistGroupToken) {
                wishlistModalHeading = 'Rename wishlist';
                wishlistModalEl.addClass('small-modal');
                wishlistModalEl.find('#wishlist-modal-create-edit-new-list #wishlist-modal-new-edit-wishlist-name').val(tmWishlist.unescapeName(settingsWishlistObject.name));
                wishlistModalEl.find('#wishlist-modal-create-edit-new-list').show();
                wishlistModalEl.find('#wishlist-modal-edit-list-footer').show();
                let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');
                if (travelDatesInputEl) {
                    let startYmd = settingsWishlistObject.date_start || '';
                    let endYmd = settingsWishlistObject.date_end || '';
                    travelDatesInputEl.value = '';
                    travelDatesInputEl.removeAttribute('data-date-start');
                    travelDatesInputEl.removeAttribute('data-date-end');
                    if (typeof moment !== 'undefined' && startYmd) {
                        let startM = moment(startYmd, 'YYYY-MM-DD');
                        let endM = endYmd ? moment(endYmd, 'YYYY-MM-DD') : null;
                        if (endM && endM.isValid()) {
                            if (startM.isSame(endM, 'day')) {
                                travelDatesInputEl.value = startM.format('MMM D, YYYY');
                            } else {
                                travelDatesInputEl.value = startM.format('MMM D, YYYY') + ' - ' + endM.format('MMM D, YYYY');
                            }
                            travelDatesInputEl.setAttribute('data-date-start', startM.format('YYYY-MM-DD'));
                            travelDatesInputEl.setAttribute('data-date-end', endM.format('YYYY-MM-DD'));
                        } else if (startM.isValid()) {
                            travelDatesInputEl.value = startM.format('MMM D, YYYY');
                            travelDatesInputEl.setAttribute('data-date-start', startM.format('YYYY-MM-DD'));
                        }
                    }
                    tmWishlist.updateWishlistTravelDatesLabelState(travelDatesInputEl);
                }
                tmWishlist.validateModalWishlistCreate('edit');
            }
            else if (subType === 'wishlistItemShare') {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'How do you want to share?';
                let collaboratingMembersCount = wishlistDetailPageWishlistObject.wishlist_collaborators.length - 1;
                wishlistModalEl.find('#wishlist-share-entry #wishlist-share-entry-collaborator-line').show();
                if (collaboratingMembersCount > 0) {
                    let entryCollaboratorLine = 'Other ' + collaboratingMembersCount + ' ' + (collaboratingMembersCount > 1 ? 'members are' : 'member is') + ' collaborating with you. <a class="' + link_color + '" href="javascript:void(0)">Update</a>'
                    wishlistModalEl.find('#wishlist-share-entry #wishlist-share-entry-collaborator-line').html(entryCollaboratorLine).show();
                }
                wishlistModalEl.find('#wishlist-share-entry').show();
            }
            else if (subType === 'wishlistItemShareInvitePublicLink') {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'Send a link to your wishlist';
                wishlistModalEl.find('#wishlist-share-invite-public-link .wishlist-share-sheet').html(tmShareSheet.render(
                    wishlistDetailPageWishlistObject.wishlist_thumb_url ?? '',
                    'Wishlist: ' + tmWishlist.unescapeName(wishlistDetailPageWishlistObject.name) + ' · ' + wishlistDetailPageWishlistObject.wishlist_tm_product_ids.length + ' saved',
                    wishlistDetailPageWishlistObject.share_links.view_only,
                    'Once you share this link, anyone can view your wishlist.'
                ));
                wishlistModalEl.find('#wishlist-share-invite-public-link').show();
            }
            else if (subType === 'wishlistItemShareInviteCollaboratorsLink') {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'Invite others to join';
                wishlistModalEl.find('#wishlist-share-invite-collaborators-link .wishlist-share-sheet').html(tmShareSheet.render(
                    wishlistDetailPageWishlistObject.wishlist_thumb_url ?? '',
                    'Join my wishlist: ' + tmWishlist.unescapeName(wishlistDetailPageWishlistObject.name) + ' · ' + wishlistDetailPageWishlistObject.wishlist_tm_product_ids.length + ' saved',
                    wishlistDetailPageWishlistObject.share_links.collaborate,
                    ''
                ));
                wishlistModalEl.find('#wishlist-share-invite-collaborators-link').show();
            }
            else if (subType === 'wishlistItemShareCollaboratorsList') {
                wishlistModalEl.find('.modal-footer').hide();
                wishlistModalHeading = 'Collaborators';
                let collaboratorListHtml = '';
                wishlistDetailPageWishlistObject.wishlist_collaborators.forEach(function (collaborator) {
                    let collaboratorAction = null;
                    if (wishlistDetailPageWishlistObject.tmwu_role === 'owner' && collaborator.wishlist_role === 'collaborator') {
                        collaboratorAction = 'remove';
                    }
                    else if (wishlistDetailPageWishlistObject.tmwu_id === collaborator.tmwu_id && wishlistDetailPageWishlistObject.tmwu_role === 'collaborator' && collaborator.wishlist_role === 'collaborator') {
                        collaboratorAction = 'leave';
                    }
                    let collaboratorListActionHtml = '';
                    if (collaboratorAction) {
                        collaboratorListActionHtml = '<div class="wishlist-share-collaborators-list-single-row-action"><button data-tmwu-id="'+collaborator.tmwu_id+'" data-action="'+collaboratorAction+'">'+collaboratorAction+'</button></div>';
                    }
                    collaboratorListHtml += '<div class="wishlist-share-collaborators-list-single-row">\n' +
                        '                            <div class="wishlist-share-collaborators-list-single-row-inner">\n' +
                        '                                <div class="wishlist-share-collaborators-list-single-row-avatar">\n' +
                        '                                    <div class="wishlist-share-collaborators-list-single-row-avatar-inner">\n' +
                        '                                        <div class="wishlist-share-collaborators-list-single-row-avatar-initial">'+collaborator.displayName.charAt(0)+'</div>\n' +
                        '                                    </div>\n' +
                        '                                </div>\n' +
                        '                                <div class="wishlist-share-collaborators-list-single-row-name">\n' +
                        '                                    <div class="wishlist-share-collaborators-list-single-row-name-main">' + (wishlistDetailPageWishlistObject.tmwu_id === collaborator.tmwu_id ? 'You' : collaborator.displayName) + '</div>\n' +
                        '                                    <div class="wishlist-share-collaborators-list-single-row-name-tagline">'+(collaborator.wishlist_role === 'owner' ? 'Owner' : '')+'</div>\n' +
                        '                                </div>\n' +
                        '                                ' + collaboratorListActionHtml +
                        '                            </div>\n' +
                        '                        </div> ';
                });
                wishlistModalEl.find('#wishlist-share-collaborators-list').html(collaboratorListHtml).show();
            }
            wishlistModalEl.find('.wishlist-modal-heading').text(wishlistModalHeading);
            wishlistModalEl.css('display', 'flex');
            $("body").css("overflow","hidden");

            if (['createList', 'wishlistItemRename'].includes(subType)) {
                tmWishlist.initWishlistTravelDatesPicker();
            }
        },

        hideWishlistModal: function () {
            if (wishlistModalEl.is(':visible')) {
                if (wishlistTravelDatesPicker && typeof wishlistTravelDatesPicker.hide === 'function') {
                    wishlistTravelDatesPicker.hide();
                }
                wishlistModalEl.css('display', 'none');
                $("body").css("overflow","auto");
                addingTmProductIdToWishlist = null;
                movingTmProductIdToWishlist = null;
                creatingWishlistOnly = false;
                settingsWishlistObject = null;
                tmWishlist.refreshWishlistStatusToAllProducts(); // a heart left in its "adding" state goes back to the outline
            }
        },

        handleFavoriteClick: function( e ){
            const el = e.target.closest('.favorite-icon');
            if (!el) return;

            e.preventDefault();
            const tmProductId = el.getAttribute('data-tm-activity-id');
            const tmDestinationNameData = el.getAttribute('data-tm-wishlist-name') || el.getAttribute('data-tm-destination-name'); // "🇮🇹 Rome - 2026"
            if ( tmDestinationNameData ){                
                $('#wishlist-modal #wishlist-modal-new-edit-wishlist-name').val(tmDestinationNameData);
            }
            if (tmProductId && tmProductId > 0) {
                tmWishlist.toggleWishlistStatusForTmProduct(tmProductId);
            }            
        }
    }
}(window);

jQuery(document).on('tmActivitiesSubsetListRefreshed', function () {
    tmWishlist.refreshWishlistStatusToAllProducts();
});


document.addEventListener('touchstart', function(e) {
    tmWishlist.handleFavoriteClick(e);
}, { passive: false });

// Optional: retain click for desktop
document.addEventListener('click', function(e) {
    tmWishlist.handleFavoriteClick(e);
});

$('#wishlist-modal #wishlist-modal-new-wishlist-go-button').click(function(){
    tmWishlist.showWishlistModal('createList');
});

$('#wishlist-new-card').click(function(e){ // the Wishlists page "New wishlist" card, or "Start a new wishlist" in its empty state
    e.preventDefault();
    creatingWishlistOnly = true;
    tmWishlist.showWishlistModal('createList');
});

$('#wishlist-modal #wishlist-modal-create-new-list-footer-back').click(function(){
    if (customerOrVisitorWishlists.length > 0 && !creatingWishlistOnly) {
        let moving = movingTmProductIdToWishlist;
        tmWishlist.showWishlistModal('chooseList');
        movingTmProductIdToWishlist = moving;
    }
    else {
        tmWishlist.hideWishlistModal();
    }
});

$('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').click(function(){
    let validatedName = tmWishlist.validateModalWishlistCreate('create');
    if (validatedName.length > 0 && validatedName.length <= 50 && creatingWishlistOnly) {
        $('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').attr('disabled', true);
        tmWishlist.createWishlistGroup(validatedName); // lands on the new list
        return;
    }
    if (validatedName.length > 0 && validatedName.length <= 50 && addingTmProductIdToWishlist > 0) {
        $('#wishlist-modal #wishlist-modal-create-new-list-footer-submit').attr('disabled', true);
        if (movingTmProductIdToWishlist) {
            tmWishlist.moveProductToWishlist(addingTmProductIdToWishlist, null, validatedName);
        } else {
            tmWishlist.addRemoveProductToCustomerWishlist(addingTmProductIdToWishlist, 'add', null, validatedName);
        }
        tmWishlist.hideWishlistModal();
    }
});

$(document).on('click', '#wishlist-modal .wishlist-folder-selector' , function () {
    let selectedWishlistId = $(this).attr('data-id');
    if (selectedWishlistId > 0 && addingTmProductIdToWishlist > 0) {
        if (movingTmProductIdToWishlist) {
            tmWishlist.moveProductToWishlist(addingTmProductIdToWishlist, selectedWishlistId);
        } else {
            tmWishlist.addRemoveProductToCustomerWishlist(addingTmProductIdToWishlist, 'add', selectedWishlistId);
        }
        tmWishlist.hideWishlistModal();
    }
});

$(document).on('click', '#wishlist-modal #wishlist-modal-new-wishlist-row', function () {
    let moving = movingTmProductIdToWishlist; // showWishlistModal keeps the state; hide would clear it
    tmWishlist.showWishlistModal('createList');
    movingTmProductIdToWishlist = moving;
});

// "Undo" on the removed toast: the product returns to the list(s) it was in
$(document).on('click', '.tm-toaster-undo-remove', function (e) {
    e.preventDefault();
    let tmProductId = $(this).attr('data-tm-product-id');
    let listIds = ($(this).attr('data-tm-wishlist-ids') || '').split(',').filter(Boolean);
    $('.tm-toaster-element').remove();
    if (tmProductId > 0) {
        tmWishlist.undoRemoveProductFromWishlists(tmProductId, listIds);
    }
});

// "Change" on the saved toast: choose another list for the product just saved
$(document).on('click', '.tm-toaster-change-wishlist', function (e) {
    e.preventDefault();
    let tmProductId = $(this).attr('data-tm-product-id');
    $('.tm-toaster-element').remove();
    if (tmProductId > 0) {
        addingTmProductIdToWishlist = tmProductId;
        movingTmProductIdToWishlist = tmProductId;
        tmWishlist.showWishlistModal('chooseList');
    }
});

$('#wishlist-settings-btn').click(function () {
    if ($(this).is('[data-modal-target]')) {
        return; // logged-out owner: the button opens the login modal (modal.js)
    }
    if (wishlistDetailPageWishlistObject) {
        if(wishlistDetailPageWishlistObject.tmwu_role === 'owner') {
            settingsWishlistObject = wishlistDetailPageWishlistObject
            if (settingsWishlistObject.id && settingsWishlistObject.token) {
                tmWishlist.showWishlistModal('wishlistItemSettings');
            }
        }
        else if(wishlistDetailPageWishlistObject.wishlist_collaborators.length > 1) {
            tmWishlist.showWishlistModal('wishlistItemShareCollaboratorsList');
        }
    }
});

$('#wishlist-share-btn').click(function () {
    if ($(this).is('[data-modal-target]')) {
        return; // logged-out owner: the pill opens the login modal (modal.js)
    }
    if (wishlistDetailPageWishlistObject) {
        tmWishlist.showWishlistModal('wishlistItemShare');
    }
});

$(document).on('input', '#wishlist-modal #wishlist-modal-new-edit-wishlist-name' , function () {
    tmWishlist.validateModalWishlistCreate('create');
    tmWishlist.validateModalWishlistCreate('edit');
});

$(document).on('click', '#wishlist-modal #wishlist-modal-new-edit-wishlist-travel-dates', function (e) {
    tmWishlist.initWishlistTravelDatesPicker();
    if (wishlistTravelDatesPicker && typeof wishlistTravelDatesPicker.show === 'function') {
        wishlistTravelDatesPicker.show();
        tmWishlist.positionWishlistTravelDatesPicker(this);
    }
});

$(document).on('click touchend pointerup', '.lightpick__reset-action', function () {
    if (!wishlistModalEl.is(':visible') || !wishlistTravelDatesPicker || !wishlistTravelDatesPicker.el || !wishlistTravelDatesPicker.el.contains(this)) {
        return;
    }
    setTimeout(function () {
        let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');
        let start = typeof wishlistTravelDatesPicker.getStartDate === 'function' ? wishlistTravelDatesPicker.getStartDate() : null;
        let end = typeof wishlistTravelDatesPicker.getEndDate === 'function' ? wishlistTravelDatesPicker.getEndDate() : null;
        jQuery(document).trigger('tmWishlistTravelDatesReset', {
            startDate: start ? start.format('YYYY-MM-DD') : null,
            endDate: end ? end.format('YYYY-MM-DD') : null,
            value: travelDatesInputEl ? travelDatesInputEl.value : '',
        });

        if (typeof wishlistTravelDatesPicker.hide !== 'function') {
            return;
        }
        wishlistTravelDatesPicker.hide();
    }, 0);
});

$(document).on('click touchend pointerup', '.lightpick__apply-action', function () {
    if (!wishlistModalEl.is(':visible') || !wishlistTravelDatesPicker || !wishlistTravelDatesPicker.el || !wishlistTravelDatesPicker.el.contains(this)) {
        return;
    }

    setTimeout(function () {
        let travelDatesInputEl = document.getElementById('wishlist-modal-new-edit-wishlist-travel-dates');
        let start = typeof wishlistTravelDatesPicker.getStartDate === 'function' ? wishlistTravelDatesPicker.getStartDate() : null;
        let end = typeof wishlistTravelDatesPicker.getEndDate === 'function' ? wishlistTravelDatesPicker.getEndDate() : null;
        jQuery(document).trigger('tmWishlistTravelDatesApply', {
            startDate: start ? start.format('YYYY-MM-DD') : null,
            endDate: end ? end.format('YYYY-MM-DD') : null,
            value: travelDatesInputEl ? travelDatesInputEl.value : '',
        });
    }, 0);
});

$(document).on('click', '#wishlist-modal #setting-share' , function () {
    if (wishlistDetailPageWishlistObject) {
        tmWishlist.showWishlistModal('wishlistItemShareInviteCollaboratorsLink');
    }
});

$(document).on('click', '#wishlist-modal #setting-view-only' , function () {
    if (wishlistDetailPageWishlistObject) {
        tmWishlist.showWishlistModal('wishlistItemShareInvitePublicLink');
    }
});

$(document).on('click', '#wishlist-modal #setting-rename' , function () {
    if (settingsWishlistObject) {
        editingWishlistGroupToken = settingsWishlistObject.token;
        tmWishlist.showWishlistModal('wishlistItemRename');
    }
});

$(document).on('click', '#wishlist-modal #wishlist-share-invite-public-link-btn' , function () {
    if(wishlistDetailPageWishlistObject.share_links.view_only.copyUrl !== undefined) {
        tmWishlist.showWishlistModal('wishlistItemShareInvitePublicLink');
    }
});

$(document).on('click', '#wishlist-modal #wishlist-share-invite-collaborators-link-btn' , function () {
    if(wishlistDetailPageWishlistObject.share_links.collaborate.copyUrl !== undefined) {
        tmWishlist.showWishlistModal('wishlistItemShareInviteCollaboratorsLink');
    }
});

$(document).on('click', '#wishlist-modal #wishlist-share-entry-collaborator-line' , function () {
    if(wishlistDetailPageWishlistObject.wishlist_collaborators.length > 1) {
        tmWishlist.showWishlistModal('wishlistItemShareCollaboratorsList');
    }
});

$('#wishlist-modal #wishlist-modal-edit-list-footer-back').click(function(){
    editingWishlistGroupToken = null;
    tmWishlist.showWishlistModal('wishlistItemSettings');
});

$('#wishlist-modal #wishlist-modal-edit-list-footer-submit').click(function(){
    let validatedName = tmWishlist.validateModalWishlistCreate('edit');
    if (validatedName.length > 0 && validatedName.length <= 50 && editingWishlistGroupToken !== null && editingWishlistGroupToken.length > 0) {
        $('#wishlist-modal #wishlist-modal-edit-list-footer-submit').attr('disabled', true);
        tmWishlist.renameWishlistGroup(editingWishlistGroupToken, validatedName);
    }
});


$(document).on('click', '#wishlist-modal #setting-delete' , function (e) {
    e.preventDefault();
    if (settingsWishlistObject) {
        deletingWishlistGroupToken = settingsWishlistObject.token;
        tmWishlist.hideWishlistModal();
        tmYesNoModal.showModal('Delete this wishlist?', 'It will be permanently deleted.', 'Cancel', 'Delete', 'deleteWishlistPopupClosedReopenSettings', 'deleteWishlistPopupAction')
    }
    return false;
});

$(document).on('click', '.wishlist-share-collaborators-list-single-row-action button' , function (e) {
    e.preventDefault();
    if (wishlistDetailPageWishlistObject.token && $(this).attr('data-tmwu-id').length > 0 && ['remove', 'leave'].includes($(this).attr('data-action'))) {
        tmWishlist.removeCollaboratorFromWishlist($(this).attr('data-action'), wishlistDetailPageWishlistObject.token, $(this).attr('data-tmwu-id'));
    }
});

// share buttons: components/share-sheet (share-sheet.js) handles the clicks

$(document).on('deleteWishlistPopupClosedReopenSettings' , function () {
    deletingWishlistGroupToken = null;
    if (wishlistDetailPageWishlistObject) {
        settingsWishlistObject = wishlistDetailPageWishlistObject
        if (settingsWishlistObject.id && settingsWishlistObject.token) {
            tmWishlist.showWishlistModal('wishlistItemSettings');
        }
    }
});

$(document).on('deleteWishlistPopupAction' , function () {
    if (deletingWishlistGroupToken) {
        tmWishlist.deleteWishlistGroup(deletingWishlistGroupToken);
    }
    else {
        tmYesNoModal.hideModal();
    }
});

jQuery(document).on('tmBlogUserLoginStatusChanged', function (e, data) {
    if (data.customerOrVisitorWishlists) {
        customerOrVisitorWishlists = data.customerOrVisitorWishlists;
        tmWishlist.processCustomerOrVisitorWishlists();
    }
});


$('#wishlist-modal .modal-close').click(function(){
    tmWishlist.hideWishlistModal();
});

document.addEventListener('mousedown', function(e){
    if (!wishlistModalEl.is(':visible')) {
        return;
    }

    if (e.target && typeof e.target.closest === 'function' && e.target.closest('.lightpick')) {
        wishlistLightpickMouseDownAt = Date.now();
    }
}, true);

$(document).click(function(e){
    if (
        !(
            $(e.target).parents('#wishlist-modal .display-contents-inner').length
            || $(e.target).is('#wishlist-modal .display-contents-inner')
            || $(e.target).parents('.lightpick').length
            || $(e.target).is('.lightpick')
            || (wishlistLightpickMouseDownAt && (Date.now() - wishlistLightpickMouseDownAt) < 600)
            || $(e.target).parents('#wishlist-settings-btn').length
            || $(e.target).is('#wishlist-settings-btn')
            || $(e.target).parents('#wishlist-share-btn').length
            || $(e.target).is('#wishlist-share-btn')
            || $(e.target).parents('#wishlist-share-entry-collaborator-line').length
            || $(e.target).is('#wishlist-share-entry-collaborator-line')
            || $(e.target).parents('#yes-no-modal-left-btn').length
            || $(e.target).is('#yes-no-modal-left-btn')
            || $(e.target).closest('#wishlist-new-card').length // Wishlists page: the card that opens the create step
            || $(e.target).closest('#wishlist-dates-btn').length // wishlist page: the Add dates pill's own calendar
            || $(e.target).closest('.tm-toaster-change-wishlist').length // saved toast: "Change" opens the chooser
        )
    ) {
        tmWishlist.hideWishlistModal();
    }
});
